// Extended content for LÉLUNE (frontend content, MOCKED where noted)
import { IMAGES, LIP_SHADES } from "./mock";

export const PRODUCT_DETAILS = {
  "copper-peptide-serum-30ml": {
    longDesc: {
      nl: "Copper Peptide Complex 03 is ons meest geconcentreerde herstelserum. Het biomimetische GHK-Cu koperpeptide werkt in harmonie met je huid om collageen te stimuleren, de barrière te versterken en zowel huid als hoofdhuid zichtbaar te vernieuwen. Licht, snel opneembaar en geschikt voor dagelijks gebruik.",
      en: "Copper Peptide Complex 03 is our most concentrated repair serum. The biomimetic GHK-Cu copper peptide works in harmony with your skin to boost collagen, strengthen the barrier and visibly renew both skin and scalp. Lightweight, fast-absorbing and suitable for daily use.",
    },
    ingredients: [
      { name: "GHK-Cu Copper Peptide", nl: "Stimuleert collageen & herstelt de huidbarrière.", en: "Boosts collagen & restores the skin barrier." },
      { name: "Hyaluronic Acid", nl: "Diepe hydratatie voor een vollere, gladdere huid.", en: "Deep hydration for plumper, smoother skin." },
      { name: "Niacinamide (B3)", nl: "Egaliseert de teint en verfijnt de poriën.", en: "Evens tone and refines pores." },
      { name: "Panthenol (B5)", nl: "Kalmeert en verzacht gevoelige huid.", en: "Soothes and softens sensitive skin." },
      { name: "Zinc PCA", nl: "Balanceert talg en beschermt.", en: "Balances sebum and protects." },
    ],
    howToUse: [
      { nl: "Reinig je gezicht en dep droog.", en: "Cleanse your face and pat dry." },
      { nl: "Breng 2–3 druppels aan, ’s ochtends en ’s avonds.", en: "Apply 2–3 drops, morning and evening." },
      { nl: "Masseer zacht in huid of hoofdhuid.", en: "Gently massage into skin or scalp." },
      { nl: "Volg op met je moisturizer of SPF overdag.", en: "Follow with your moisturizer or SPF during the day." },
    ],
    reviews: [
      { name: "Sanne D.", rating: 5, nl: "Mijn huid voelt na 3 weken echt steviger en rustiger.", en: "After 3 weeks my skin feels genuinely firmer and calmer." },
      { name: "Yara M.", rating: 5, nl: "Trekt snel in, geen plakkerig gevoel. Ik ben fan.", en: "Absorbs fast, no sticky feel. I'm a fan." },
      { name: "Noor K.", rating: 4, nl: "Mooie textuur, benieuwd naar langetermijnresultaat.", en: "Lovely texture, curious about long-term results." },
    ],
  },
  "color-lip-tint": {
    longDesc: {
      nl: "Een verzorgende kleur-lip tint die pigment en peptiden combineert. Buildbaar van een subtiele was tot volle kleur, met een comfortabele, niet-uitdrogende finish. Verkrijgbaar in vier tinten.",
      en: "A nourishing color lip tint that blends pigment with peptides. Buildable from a subtle wash to full color, with a comfortable, non-drying finish. Available in four shades.",
    },
    ingredients: [
      { name: "Peptide Complex", nl: "Verzorgt en verzacht de lippen.", en: "Nourishes and softens the lips." },
      { name: "Shea Butter", nl: "Rijke hydratatie en comfort.", en: "Rich hydration and comfort." },
      { name: "Jojoba Oil", nl: "Voedt en geeft een zachte glans.", en: "Nourishes and adds a soft sheen." },
      { name: "Vitamin E", nl: "Antioxidant die de lippen beschermt.", en: "Antioxidant that protects the lips." },
    ],
    howToUse: [
      { nl: "Breng aan vanuit het midden naar buiten.", en: "Apply from the center outward." },
      { nl: "Bouw op naar de gewenste intensiteit.", en: "Build up to your desired intensity." },
      { nl: "Combineer met de Lip Gloss voor extra glans.", en: "Layer with the Lip Gloss for extra shine." },
    ],
    reviews: [
      { name: "Emma V.", rating: 5, nl: "Tint 03 is prachtig — kleur die de hele dag blijft.", en: "Shade 03 is gorgeous — colour that lasts all day." },
      { name: "Lisa T.", rating: 5, nl: "Niet uitdrogend, voelt als een balm.", en: "Not drying at all, feels like a balm." },
      { name: "Fleur B.", rating: 4, nl: "Mooie tinten, ik wil ze nu allemaal.", en: "Beautiful shades, now I want them all." },
    ],
  },
  "lip-gloss": {
    longDesc: {
      nl: "Een hoogglanzende, niet-plakkerige gloss met peptiden en een subtiel vollere-lippen effect. Draag solo voor spiegelglans of over je lip tint.",
      en: "A high-shine, non-sticky gloss with peptides and a subtle plumping effect. Wear solo for mirror shine or over your lip tint.",
    },
    ingredients: [
      { name: "Peptide Complex", nl: "Verzorgt en doet de lippen voller lijken.", en: "Nourishes and visibly plumps the lips." },
      { name: "Hyaluronic Acid", nl: "Hydrateert en verzacht.", en: "Hydrates and softens." },
      { name: "Peppermint Oil", nl: "Zorgt voor een subtiel plumping-effect.", en: "Delivers a subtle plumping effect." },
      { name: "Vitamin E", nl: "Beschermende antioxidant.", en: "Protective antioxidant." },
    ],
    howToUse: [
      { nl: "Breng een dun laagje aan op de lippen.", en: "Apply a thin layer to the lips." },
      { nl: "Draag solo of over de Color Lip Tint.", en: "Wear solo or over the Color Lip Tint." },
      { nl: "Herhaal gedurende de dag voor glans.", en: "Reapply throughout the day for shine." },
    ],
    reviews: [
      { name: "Iris H.", rating: 5, nl: "Zo glanzend en totaal niet plakkerig!", en: "So shiny and not sticky at all!" },
      { name: "Julia S.", rating: 5, nl: "Lekker fris gevoel, lippen ogen voller.", en: "Lovely fresh feel, lips look fuller." },
      { name: "Roos P.", rating: 4, nl: "Perfect over de tint. Mooie glans.", en: "Perfect over the tint. Beautiful shine." },
    ],
  },
  "pdrn-pink-peptide-serum-30ml": {
    longDesc: {
      nl: "PDRN Pink Peptide Serum is ons roze glow-serum geïnspireerd op K-beauty. Rose PDRN werkt samen met een complex van 5 peptiden om de huid diep te hydrateren, de barrière te versterken en een gezonde, stralende teint te geven. Licht van textuur, snel opneembaar en geschikt voor alle huidtypes.",
      en: "PDRN Pink Peptide Serum is our pink glow serum inspired by K-beauty. Rose PDRN works together with a 5-peptide complex to deeply hydrate the skin, strengthen the barrier and deliver a healthy, radiant complexion. Lightweight, fast-absorbing and suitable for all skin types.",
    },
    ingredients: [
      { name: "Rose PDRN", nl: "Stimuleert herstel en geeft een zichtbare glow.", en: "Stimulates repair and delivers a visible glow." },
      { name: "5 Peptide Complex", nl: "Ondersteunt stevigheid en elasticiteit.", en: "Supports firmness and elasticity." },
      { name: "Hyaluronic Acid", nl: "Diepe hydratatie voor een vollere huid.", en: "Deep hydration for plumper skin." },
      { name: "Niacinamide (B3)", nl: "Egaliseert de teint en verfijnt de poriën.", en: "Evens tone and refines pores." },
      { name: "Panthenol (B5)", nl: "Kalmeert en verzacht de huid.", en: "Soothes and softens the skin." },
    ],
    howToUse: [
      { nl: "Reinig je gezicht en dep droog.", en: "Cleanse your face and pat dry." },
      { nl: "Breng 2–3 druppels aan, ’s ochtends en ’s avonds.", en: "Apply 2–3 drops, morning and evening." },
      { nl: "Masseer zacht in tot volledig opgenomen.", en: "Gently massage in until fully absorbed." },
      { nl: "Volg op met je moisturizer of SPF overdag.", en: "Follow with your moisturizer or SPF during the day." },
    ],
    reviews: [
      { name: "Amber J.", rating: 5, nl: "Mijn huid straalt echt na een paar dagen. Verslavend!", en: "My skin genuinely glows after a few days. Addictive!" },
      { name: "Feline R.", rating: 5, nl: "Zacht, hydraterend en een prachtige roze kleur.", en: "Soft, hydrating and a gorgeous pink colour." },
      { name: "Naomi K.", rating: 4, nl: "Fijne textuur, trekt snel in zonder plakkerig gevoel.", en: "Lovely texture, absorbs fast without a sticky feel." },
    ],
  },
  "lipliner": {
    longDesc: {
      nl: "Onze Lip Liner definieert de lippen met een romige, glijdende formule verrijkt met peptiden. Perfect om de contour te verfijnen en je Color Lip Tint langer te laten blijven. Nu verkrijgbaar in vier tinten: 22, 23, 25 en 26.",
      en: "Our Lip Liner defines the lips with a creamy, gliding formula enriched with peptides. Perfect to refine the contour and make your Color Lip Tint last longer. Now available in four shades: 22, 23, 25 and 26.",
    },
    ingredients: [
      { name: "Peptide Complex", nl: "Verzorgt de lippen tijdens het dragen.", en: "Cares for the lips while worn." },
      { name: "Jojoba Oil", nl: "Zorgt voor een romige, gladde glijding.", en: "Delivers a creamy, smooth glide." },
      { name: "Vitamin E", nl: "Beschermende antioxidant.", en: "Protective antioxidant." },
      { name: "Carnauba Wax", nl: "Langhoudende, egale kleurafgifte.", en: "Long-wear, even colour payoff." },
    ],
    howToUse: [
      { nl: "Teken de contour van je lippen na.", en: "Trace the contour of your lips." },
      { nl: "Vul eventueel de lippen volledig in als basis.", en: "Optionally fill in the lips fully as a base." },
      { nl: "Werk af met de Color Lip Tint of Lip Gloss.", en: "Finish with the Color Lip Tint or Lip Gloss." },
    ],
    reviews: [
      { name: "Nina W.", rating: 5, nl: "Glijdt zacht, trekt niet aan de lippen.", en: "Glides softly, doesn't tug the lips." },
      { name: "Sara L.", rating: 5, nl: "Mooie terracotta kleur, precies wat ik zocht!", en: "Beautiful terracotta shade, exactly what I wanted!" },
      { name: "Dana R.", rating: 4, nl: "Blijft lang zitten onder de tint.", en: "Lasts well under the tint." },
    ],
  },
};

export const TINT_LINER_BUNDLE = {
  id: "tint-liner-bundle",
  image: IMAGES.lipliner,
  price: 19.95,
  original: 23.9,
  includes: ["color-lip-tint", "lipliner"],
  name: { nl: "Lip Duo", en: "Lip Duo" },
  subtitle: { nl: "Lip Tint + Lip Liner", en: "Lip Tint + Lip Liner" },
  desc: {
    nl: "De perfecte lippencombinatie: onze Color Lip Tint in jouw tint naar keuze én de nieuwe Lip Liner. Samen voor één mooie prijs.",
    en: "The perfect lip combination: our Color Lip Tint in your chosen shade plus the new Lip Liner. Together at one lovely price.",
  },
};

export const BUNDLE = {
  id: "ritual-bundle",
  image: IMAGES.serum,
  price: 49.95,
  original: 58.85,
  includes: ["copper-peptide-serum-30ml", "color-lip-tint", "lipliner"],
  name: { nl: "The Ritual", en: "The Ritual" },
  subtitle: { nl: "Serum · Lip Tint · Lip Liner", en: "Serum · Lip Tint · Lip Liner" },
  desc: {
    nl: "Het complete LÉLUNE-ritueel in één set: ons Copper Peptide Complex serum, een Color Lip Tint in jouw tint naar keuze, en de Lip Liner. Samen voordeliger.",
    en: "The complete LÉLUNE ritual in one set: our Copper Peptide Complex serum, a Color Lip Tint in your chosen shade, and the Lip Liner. Better together.",
  },
};

// Playful shade-finder quiz -> recommends 02 / 03 / 14 / 20
export const SHADE_QUIZ = {
  questions: [
    {
      id: "undertone",
      q: { nl: "Wat past het best bij jouw ondertoon?", en: "Which best matches your undertone?" },
      options: [
        { nl: "Koel & roze", en: "Cool & pink", value: "20" },
        { nl: "Warm & perzik", en: "Warm & peach", value: "02" },
        { nl: "Neutraal", en: "Neutral", value: "14" },
        { nl: "Diep & rijk", en: "Deep & rich", value: "03" },
      ],
    },
    {
      id: "intensity",
      q: { nl: "Hoeveel kleur wil je?", en: "How much colour do you want?" },
      options: [
        { nl: "Subtiel", en: "Subtle", value: "14" },
        { nl: "Medium", en: "Medium", value: "02" },
        { nl: "Statement", en: "Statement", value: "20" },
        { nl: "Diep & vol", en: "Deep & full", value: "03" },
      ],
    },
    {
      id: "vibe",
      q: { nl: "Welke vibe spreekt je aan?", en: "Which vibe speaks to you?" },
      options: [
        { nl: "Natuurlijk", en: "Natural", value: "14" },
        { nl: "Romantisch", en: "Romantic", value: "02" },
        { nl: "Bold", en: "Bold", value: "20" },
        { nl: "Mysterieus", en: "Mysterious", value: "03" },
      ],
    },
  ],
};

export const shadeByCode = (code) => LIP_SHADES.find((s) => s.code === code) || LIP_SHADES[0];

export const FAQ = [
  {
    q: { nl: "Wanneer wordt mijn bestelling verzonden?", en: "When is my order shipped?" },
    a: { nl: "Bestel je voor 15:00 op een werkdag, dan versturen we je pakket dezelfde dag vanuit Nederland.", en: "Order before 3PM on a business day and we ship your parcel the same day from the Netherlands." },
  },
  {
    q: { nl: "Wat kost verzending?", en: "How much is shipping?" },
    a: { nl: "Verzending kost €4,95. Bij bestellingen vanaf €100 verzenden we gratis.", en: "Shipping is €4.95. Orders from €100 ship for free." },
  },
  {
    q: { nl: "Wat betekent pre-order bij het serum?", en: "What does pre-order mean for the serum?" },
    a: { nl: "Het Copper Peptide Complex serum is in productie. Schrijf je in op de wachtlijst en je krijgt als eerste bericht zodra het gelanceerd wordt.", en: "The Copper Peptide Complex serum is in production. Join the waitlist and you'll be the first to hear when it launches." },
  },
  {
    q: { nl: "Zijn jullie producten vegan en cruelty-free?", en: "Are your products vegan and cruelty-free?" },
    a: { nl: "Ja. Al onze formules zijn 100% vegan, cruelty-free en dermatologisch getest.", en: "Yes. All our formulas are 100% vegan, cruelty-free and dermatologically tested." },
  },
  {
    q: { nl: "Kan ik retourneren?", en: "Can I return my order?" },
    a: { nl: "Ongeopende producten kun je binnen 14 dagen retourneren. Neem contact op via de website.", en: "Unopened products can be returned within 14 days. Get in touch via the website." },
  },
];

// Extra UI labels for the new features
export const TX = {
  nl: {
    navFaq: "FAQ",
    navShade: "Shade Finder",
    viewDetails: "Bekijk product",
    ingredients: "Ingrediënten",
    howToUse: "Zo gebruik je het",
    reviews: "Reviews",
    keyIngredients: "Belangrijkste ingrediënten",
    backToShop: "Terug naar shop",
    addToCart: "In winkelmand",
    preorderCta: "Zet op wachtlijst",
    // Waitlist
    waitlistTitle: "Wees er als eerste bij",
    waitlistText: "Schrijf je in en ontvang bericht zodra het serum gelanceerd wordt.",
    waitlistPlaceholder: "Jouw e-mailadres",
    waitlistBtn: "Op de wachtlijst",
    waitlistOk: "Je staat op de wachtlijst!",
    waitlistDup: "Je staat al op de wachtlijst.",
    // Shipping
    shippingLine: "Verzending €4,95 · gratis vanaf €100",
    freeShippingReached: "Je hebt gratis verzending!",
    freeShippingLeft: (v) => `Nog €${v} tot gratis verzending`,
    // Bundle
    bundleKicker: "GIFT SET",
    bundleTitle: "The Ritual — compleet & voordelig",
    bundleSave: "Bespaar",
    bundleChoose: "Kies je lip tint tint",
    bundleAdd: "Voeg set toe",
    // Shade finder
    shadeKicker: "SHADE FINDER",
    shadeTitle: "Vind jouw perfecte tint",
    shadeIntro: "Beantwoord 3 vragen en wij vinden de Color Lip Tint die bij je past.",
    shadeStart: "Start de quiz",
    shadeResult: "Jouw perfecte tint",
    shadeAdd: "Voeg tint toe",
    shadeRetry: "Opnieuw",
    question: "Vraag",
    of: "van",
    // FAQ
    faqKicker: "HELP",
    faqTitle: "Veelgestelde vragen",
    // Brand
    brandKicker: "OVER LÉLUNE",
    brandTitle: "Zachte kracht, eerlijk mooi.",
    brandText: "LÉLUNE is geboren in Nederland vanuit één overtuiging: échte verzorging hoeft niet ingewikkeld te zijn. We combineren biomimetische peptiden met clean, minimalistische formules die de huid en lippen voeden zonder ruis. Vegan, cruelty-free en met trots gemaakt in NL.",
    learnMore: "Lees ons verhaal",
  },
  en: {
    navFaq: "FAQ",
    navShade: "Shade Finder",
    viewDetails: "View product",
    ingredients: "Ingredients",
    howToUse: "How to use",
    reviews: "Reviews",
    keyIngredients: "Key ingredients",
    backToShop: "Back to shop",
    addToCart: "Add to cart",
    preorderCta: "Join waitlist",
    waitlistTitle: "Be the first to know",
    waitlistText: "Sign up and we'll email you the moment the serum launches.",
    waitlistPlaceholder: "Your email address",
    waitlistBtn: "Join the waitlist",
    waitlistOk: "You're on the waitlist!",
    waitlistDup: "You're already on the waitlist.",
    shippingLine: "Shipping €4.95 · free from €100",
    freeShippingReached: "You've unlocked free shipping!",
    freeShippingLeft: (v) => `€${v} away from free shipping`,
    bundleKicker: "GIFT SET",
    bundleTitle: "The Ritual — complete & better value",
    bundleSave: "Save",
    bundleChoose: "Choose your lip tint shade",
    bundleAdd: "Add the set",
    shadeKicker: "SHADE FINDER",
    shadeTitle: "Find your perfect shade",
    shadeIntro: "Answer 3 questions and we'll find the Color Lip Tint that suits you.",
    shadeStart: "Start the quiz",
    shadeResult: "Your perfect shade",
    shadeAdd: "Add shade",
    shadeRetry: "Retry",
    question: "Question",
    of: "of",
    faqKicker: "HELP",
    faqTitle: "Frequently asked questions",
    brandKicker: "ABOUT LÉLUNE",
    brandTitle: "Gentle power, honestly beautiful.",
    brandText: "LÉLUNE was born in the Netherlands from a single belief: real care doesn't have to be complicated. We blend biomimetic peptides with clean, minimalist formulas that nourish skin and lips without the noise. Vegan, cruelty-free and proudly made in NL.",
    learnMore: "Read our story",
  },
};
